/**
 * Created by roi on 27/04/17.
 */

const hostnameServidorWeb = window.location.hostname;

const env = {
  development: {
    API_SERVER_URL: `http://${hostnameServidorWeb}:8585`,
    BUCKET_S3_URL: "https://static-pre.meteo.cat",
    FOLDER_S3: "webxom",
    FOLDER_TOPOJSON: "assets-w3/json/topojson"
  },
  proves: {
    API_SERVER_URL: `https://${hostnameServidorWeb}:8585`,
    BUCKET_S3_URL: "https://static-pre.meteo.cat",
    FOLDER_S3: "webxom",
    FOLDER_TOPOJSON: "assets-w3/json/topojson"
  },
  pre: {
    API_SERVER_URL: `https://${hostnameServidorWeb}:8585`,
    BUCKET_S3_URL: "https://static-pre.meteo.cat",
    FOLDER_S3: "webxom",
    FOLDER_TOPOJSON: "assets-w3/json/topojson"
  },
  pro: {
    API_SERVER_URL: `https://${hostnameServidorWeb}:8585`,
    BUCKET_S3_URL: "https://static-m.meteo.cat",
    FOLDER_S3: "webxom",
    FOLDER_TOPOJSON: "assets-w3/json/topojson"
  }
};

const config = () => {
  var node_env = process.env.REACT_APP_ENVIROMENT || "development";
  return env[node_env];
};

export default config;



// WEBPACK FOOTER //
// ./src/configuracioEntorns.js